import { render, staticRenderFns } from "./form-item-wrapper.vue?vue&type=template&id=7d78f48a&scoped=true"
import script from "./form-item-wrapper.vue?vue&type=script&lang=js"
export * from "./form-item-wrapper.vue?vue&type=script&lang=js"
import style0 from "./form-item-wrapper.vue?vue&type=style&index=0&id=7d78f48a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d78f48a",
  null
  
)

export default component.exports